import { DexieDb } from "../dexie-db";
import { VesselPositionData, VesselPositionDataExtended } from "../services/types/position-service.types";
import { DbModelBase } from "./db-model";
import { VesselInfo } from "./types/vessels-model.types";

export class DbModelImpl extends DbModelBase {
  constructor() {
    super();

    this._db = new DexieDb();
  }

  private _db: DexieDb;

  async populatePositionsTable(allPositions: Map<number, VesselPositionDataExtended>) {
    const allPositionsArrayData = Array.from(allPositions.values());
    //filter valid imos - valid imos should have 7 digits 
    const allPositionsArray = allPositionsArrayData?.filter(val=>val.imo!.toString()!.length == 7);
    const allPositionsBlob = JSON.stringify(allPositionsArray);

    try {
      await this._db.open();
      if (await this._db.table("positions").count() > 0) {
        await this._db.table("positions").bulkPut([{ imo: 1, data: allPositionsBlob}]);
      } else {
        await this._db.table("positions").bulkAdd([{ imo: 1, data: allPositionsBlob}]);
      }
    } catch (err) {
      console.warn(err)
      throw err;
    }
  }

  async getAllPositionsRecords(): Promise<VesselPositionDataExtended[]> {
    let positions = [];
    try {
      await this._db.open();
      positions = await this._db.table("positions").toArray();
    } catch (err) {
      console.warn(err)
      throw err;
    }
    return positions.length === 0 ? [] : JSON.parse(positions[0].data);
  }

  async populateVesselsTable(maerskVessels: Map<number, VesselInfo>, nonMaerskVessels: Map<number, VesselInfo>) {
    const allVesselsData = Array.from(maerskVessels.values()).concat(Array.from(nonMaerskVessels.values()));
    //filter valid imos - valid imos should have 7 digits 
    const allVessels = allVesselsData?.filter(val=>val.imoNo!.toString()!.length == 7);
    const allVesselsBlob = JSON.stringify(allVessels);

    try {
      await this._db.open();
      if (await this._db.table("vessels").count() > 0) {
        await this._db.table("vessels").bulkPut([{ imoNo: 1, data: allVesselsBlob}]);
      } else {
        await this._db.table("vessels").bulkAdd([{ imoNo: 1, data: allVesselsBlob}]);
      }
    } catch (err) {
      console.warn(err)
      throw err;
    }
  }

  async getAllVesselsRecords(): Promise<VesselInfo[]> {
    let vessels = [];
    try {
      await this._db.open();
      vessels = await this._db.table("vessels").toArray();
    } catch (err) {
      console.warn(err)
      throw err;
    }
    return vessels.length === 0 ? [] : JSON.parse(vessels[0].data);
  }
}
